import { Effect } from "../../Materials/effect";
var name = 'prePassDeclaration';
var shader = "#ifdef PREPASS\n#extension GL_EXT_draw_buffers : require\n#ifdef WEBGL2\nlayout(location=0) out highp vec4 glFragData[{X}];\nhighp vec4 gl_FragColor;\n#endif\n#ifdef PREPASS_DEPTHNORMAL\nvarying highp vec3 vViewPos;\n#endif\n#ifdef PREPASS_VELOCITY\nvarying highp vec4 vCurrentPosition;\nvarying highp vec4 vPreviousPosition;\n#endif\n#endif\n";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var prePassDeclaration = { name: name, shader: shader };
//# sourceMappingURL=prePassDeclaration.js.map